import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import DatePicker from 'react-datepicker';
import { InputLabel, InputError } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { FormComponent, FormWrapper, DatesWrapper, DateInputWrapper } from 'src/domains/layouts/shared/cms/form/Form.style';
import { RedirectOptions } from './RedirectOptions';
import { DateState } from './Date.state';
import { Select } from 'src/domains/layouts/shared/formComponents/Select/components/Select';
import { UploadImg } from 'src/components/UploadImg/UploadImg';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { Textarea } from 'src/domains/layouts/shared/formComponents/textarea/Textarea';
import { HeadlineCarouselState } from '../HeadlineCarousel.state';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

interface PropsTypes {
    headlineCarouselState: HeadlineCarouselState,
}

export const HeadlineForm = observer('HeadlineForm', ({ headlineCarouselState }: PropsTypes) => {
    const [state] = useState(() => new DateState(headlineCarouselState.headlineBannersData));
    const { onChangeStartDate, onBlurStartDate, onChangeEndDate, onBlurEndDate, startDateError, endDateError } = state;

    const {
        title,
        subtitle,
        btnTitle,
        btnColor,
        termsFull,
        redirectType,
        imageDesktop,
        imageTablet,
        imageMobile,
        redirectOptions,
        handleCreate,
        handleResetForm,
        resetForm,
        handleEdit,
        bgColor,
        isEditMode,
        isLoading,
        startDate,
        endDate,
        imagesError,
    } = headlineCarouselState.headlineBannersData;
    
    return (
        <FormWrapper>
            <FormHeader isEditMode={isEditMode} defaultLabel='Create new headline carousel' editModeLabel='Edit headline carousel' resetForm={resetForm}/>
            <FormComponent onSubmit={(e: React.FormEvent<HTMLFormElement>): void => {
                e.preventDefault();
            }}>
                <Loader isActive={isLoading}/>

                <Input
                    label='Headline *'
                    formInputState={title}
                    dataTest='set-headline'
                />

                <Input
                    label='Subheading *'
                    formInputState={subtitle}
                    dataTest='add-subheading'
                />

                <DatesWrapper>
                    <DateInputWrapper>
                        <InputLabel>Start date *</InputLabel>
                        <DatePicker
                            selected={startDate}
                            onChange={onChangeStartDate}
                            onBlur={onBlurStartDate}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            timeCaption='time'
                            dateFormat='MMMM d, yyyy h:mm aa'
                            id='Start-date'
                        />
                        {startDateError ? <InputError>This field is required.</InputError> : null}
                    </DateInputWrapper>
                    <DateInputWrapper>
                        <InputLabel>End date *</InputLabel>
                        <DatePicker
                            selected={endDate}
                            onChange={onChangeEndDate}
                            onBlur={onBlurEndDate}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            timeCaption='time'
                            dateFormat='MMMM d, yyyy h:mm aa'
                            id='End-date'
                        />
                        {endDateError ? <InputError>This field is required.</InputError> : null}
                    </DateInputWrapper>
                </DatesWrapper>
                
                <InputLabel>Select redirection</InputLabel>
                <Select selectOptions={redirectOptions} stateValue={redirectType} dataTest='select-headline-redirection' />

                <RedirectOptions headlineCarouselState={headlineCarouselState} />

                <Input
                    label='Button title (optional)'
                    formInputState={btnTitle}
                    dataTest='set-button-title'
                />
                <Input
                    label='Button color (optional)'
                    formInputState={btnColor}
                    dataTest='set-button-color'
                />

                <Input
                    label='Background color (optional)'
                    formInputState={bgColor}
                    dataTest='set-backgroud-colour'
                />

                <Textarea 
                    label='Full terms (optional)'
                    placeholder='Type something...'
                    formState={termsFull}
                    ckeditor
                />

                <div>
                    <UploadImg
                        title='Image Upload Desktop (1112 x 256px) *'
                        uploadImageState={imageDesktop}
                        hasFullWidthPreview={true}
                        dataTest='set-desktop-image'
                    />
                    <UploadImg
                        title='Image Upload Tablet (732 x 256px) *'
                        uploadImageState={imageTablet}
                        hasFullWidthPreview={true}
                        dataTest='set-tablet-image'
                    />
                    <UploadImg
                        title='Image Upload Mobile (343 x 208px) *'
                        uploadImageState={imageMobile}
                        hasFullWidthPreview={true}
                        dataTest='set-mobile-image'
                    />
                    {imagesError !== null ? <InputError>{imagesError}</InputError> : null}
                </div>

                <FormButtons
                    onCreate={handleCreate}
                    onUpdate={handleEdit}
                    onCancel={handleResetForm}
                    isEditMode={isEditMode}
                />
                
            </FormComponent>
        </FormWrapper>
    );
});

